export const dateTimeFormats = {
    'en-US': {
        monthName: {
            month: 'long'
        }
    },
    'fr-CA': {
        monthName: {
            month: 'long'
        }
    }
};
